import React from "react";
import { Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";

export default function ClientLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => { await logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-[#FAFAF7]">
      <header className="border-b border-zinc-200 bg-white px-6 py-4 flex items-center justify-between">
        <Link to="/portal" className="flex items-center gap-2" data-testid="portal-home-link">
          <div className="h-2.5 w-2.5 rounded-full bg-[#C4A47C]" />
          <span className="font-display font-medium tracking-tight">Projevista · Sales Portal</span>
        </Link>
        <div className="flex items-center gap-3">
          <div className="text-xs text-zinc-600 hidden md:block" data-testid="portal-user-email">{user?.email}</div>
          <button onClick={onLogout} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border border-zinc-300 text-sm" data-testid="portal-logout"><LogOut className="h-4 w-4" /> Sign out</button>
        </div>
      </header>
      <Outlet />
    </div>
  );
}
